import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right\"><defs><style type=\"text/css\"></style></defs><path d=\"M384.30607 256.204389l0 512.41186 320.259338-256.206443L384.30607 256.204389z\" p-id=\"2061\" fill=\"#6a9bae\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol